import WelcomeMessages from "@/domain/entities/dashboard/WelcomeMessages";
import welcomeMessagesMapper from "@/mappers/user/welcomeMessageMapper";
import { useWelcomeMessages } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMemo } from "react";
import useLiveErrorNotifier from "./utils/useLiveErrorNotifier";

const useGetMailInfosData = (): WelcomeMessages | undefined => {
    const { data, error } = useWelcomeMessages();

    useLiveErrorNotifier(error, {
        titleTranslationKey: "errors.dashboardSummary",
    });

    return useMemo(
        () => (data ? welcomeMessagesMapper(data) : undefined),
        [data],
    );
};

export default useGetMailInfosData;
